import { useEffect, useState } from "react";

import { CharityApiService } from "../services/CharityApiService";
import { CampaignPhase } from "../types";

/**
 * Whether the campaign has closed, as the service reports its phase.
 *
 * Null only while the totals are still being read. Totals that cannot be read
 * settle as open: the page keeps its forms, and the service refuses the write
 * if the campaign has in fact closed.
 *
 * @returns True once closed, false while open or unreadable, null while loading
 */
export const useIsCampaignClosed = (): boolean | null => {
  const [isClosed, setIsClosed] = useState<boolean | null>(null);

  useEffect(() => {
    let isMounted = true;

    const loadPhase = async (): Promise<void> => {
      try {
        const snapshot = await CharityApiService.getCampaignTotalsAsync();
        if (isMounted) {
          setIsClosed(snapshot.phase === CampaignPhase.Closed);
        }
      } catch {
        if (isMounted) {
          setIsClosed(false);
        }
      }
    };

    loadPhase();
    return () => {
      isMounted = false;
    };
  }, []);

  return isClosed;
};
